import React from "react";
import { getDevImpersonationLoginName } from "../Utility/devImpersonation";

/**
 * Dev-only reminder that the app is showing another user's data.
 * Renders nothing unless impersonation is active (never in production builds).
 */
const DevImpersonationBanner: React.FC = () => {
  const loginName = getDevImpersonationLoginName();

  if (!loginName) {
    return null;
  }

  return (
    <div
      role="status"
      className="fixed bottom-4 left-4 z-[9999] rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-lg"
    >
      DEV: impersonating {loginName} (saves are real)
    </div>
  );
};

export default DevImpersonationBanner;
